export default __webpack_public_path__ + "static/media/invulnerablesoul.bca1d7f2.png";